"use client"

import ErrorPage from "@/components/pages/error/ErrorPage"
interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

const Error: React.FC<ErrorProps> = ({ error }) => {
  return (
    <>
      <ErrorPage code={error.message} />
    </>
  )
}
export default Error
